import { Card, CardContent, styled, SxProps, Theme } from '@mui/material';
import { PropsWithChildren } from 'react';
import { mergeSx } from 'shared/_ui/utils';

const CONTAINER_SX = {
	display: 'flex',
	flexDirection: 'column',
	gap: 2,
} as const;

export const FieldsContainer = styled('div', { name: 'FieldsContainer' })(CONTAINER_SX);

type CardFieldsContainerProps = PropsWithChildren<{
	sx?: SxProps<Theme>;
	contentSx?: SxProps<Theme>;
}>;

export function CardFieldsContainer({ children, sx, contentSx }: CardFieldsContainerProps) {
	return (
		<Card sx={sx}>
			<CardContent sx={mergeSx(CONTAINER_SX, contentSx)}>{children}</CardContent>
		</Card>
	);
}
